// extracted by mini-css-extract-plugin
export var carousel = "CpG2f";
export var title = "nsBNb";